var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6808 9.31786C16.8936 9.62236 17 9.77464 17 10C17 10.2254 16.8936 10.3776 16.6808 10.6821C15.7245 12.0504 13.2824 15 10 15C6.71755 15 4.27547 12.0504 3.31923 10.6821C3.10641 10.3776 3 10.2254 3 10C3 9.77464 3.10641 9.62236 3.31923 9.31786C4.27547 7.9496 6.71755 5 10 5C13.2824 5 15.7245 7.9496 16.6808 9.31786Z",
    stroke: "#3D4AF5",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 8.8954 11.1046 8 10 8C8.8954 8 8 8.8954 8 10C8 11.1046 8.8954 12 10 12C11.1046 12 12 11.1046 12 10Z",
    stroke: "#3D4AF5",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIc);
export default __webpack_public_path__ + "static/media/eye_ic.dd6c95405e4ad3b86fcbc69e66728d5e.svg";
export { ForwardRef as ReactComponent };